import _isEqual from 'lodash/isEqual';

import { IReviewCreateBody, IReviewUpdatePersonalDataBody } from '../../../interfaces/reviews';
import { handTypograf, typograf } from '../../../utils/typograf';
import { FIELDS_FOR_UPDATING_PERSONAL_DATA } from '../constants/common';
import { TFormInputs } from '../types';

import { isStepReviewTextFormField } from './helpers';
import { prepareSubmitData } from './prepareSubmitData';

const fieldsWithoutChanges: (keyof IReviewCreateBody)[] = [
  'utm',
  'fingerPrint',
  'isRecommendedByUser',
  'isAboutSravni',
  'id',
  'positiveTags',
  'negativeTags',
  'specificProductName', // productId достаточно для понимания, изменился ли продукт
];

export const getPersonalDataFromChanges = ({
  data,
  initData,
}: {
  data: IReviewCreateBody;
  initData: TFormInputs;
}): [IReviewUpdatePersonalDataBody, boolean] => {
  let isNotOnlyPersonalDataChanged = false;

  const preparedInitData = prepareSubmitData({ data: initData, isEdit: false, fingerPrint: null });
  const initDataReadyToComparison = Object.fromEntries(
    Object.entries(preparedInitData).filter(
      ([key]: [keyof IReviewCreateBody, any]) => !fieldsWithoutChanges.includes(key),
    ),
  );

  const personalData = Object.keys(initDataReadyToComparison).reduce((acc, field: keyof IReviewCreateBody) => {
    const isPersonalField = FIELDS_FOR_UPDATING_PERSONAL_DATA.includes(field) && field !== 'reviewObjectId';

    let isFieldChanged = !_isEqual(initDataReadyToComparison[field], data[field]);

    if (isFieldChanged && isStepReviewTextFormField(field)) {
      // Если юзер трогал текстовое поле, то типограф обработал значение, и оно не совпадает с полученным из сервиса. Для корректного сравнения нужно сравнивать с типографированной версией.
      const typografedInitField = typograf.execute(handTypograf(initDataReadyToComparison[field] ?? ''));

      isFieldChanged = !_isEqual(typografedInitField, data[field]);
    }

    if (!isPersonalField && isFieldChanged) {
      isNotOnlyPersonalDataChanged = true;
    }

    if (isPersonalField) {
      return { ...acc, [field]: data[field] };
    }

    return acc;
  }, {});

  return [personalData, isNotOnlyPersonalDataChanged];
};
